const BTG = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18.7608C14.8384 18.7608 18.7608 14.8384 18.7608 9.99998C18.7608 5.16153 14.8384 1.2392 10 1.2392C5.16155 1.2392 1.23921 5.16153 1.23921 9.99998C1.23921 14.8384 5.16155 18.7608 10 18.7608Z"
      fill="white"
    />
    <path
      d="M10 0C4.47843 0 0 4.47843 0 10C0 15.5216 4.47843 20 10 20C15.5216 20 20 15.5216 20 10C20 4.47843 15.5216 0 10 0ZM10 17.698C5.74902 17.698 2.30196 14.251 2.30196 10C2.30196 5.74902 5.74902 2.30196 10 2.30196C14.251 2.30196 17.698 5.74902 17.698 10C17.698 14.251 14.251 17.698 10 17.698Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M6.66624 13.4199L7.05056 12.6512H11.6662C12.3015 12.6512 12.8192 12.1336 12.8192 11.4983C12.8192 10.863 12.3015 10.3453 11.6662 10.3453H7.81919V9.57672H11.6662C12.729 9.57672 13.5878 10.4395 13.5878 11.4983C13.5878 12.561 12.7251 13.4199 11.6662 13.4199H6.66624Z"
      fill="#132365"
    />
    <path
      d="M11.6664 13.6312H6.32135L6.92135 12.4351H11.6704C12.188 12.4351 12.6115 12.0116 12.6115 11.4939C12.6115 10.9763 12.188 10.5528 11.6704 10.5528H7.60762V9.35669H11.6664C12.8429 9.35669 13.8037 10.3136 13.8037 11.4939C13.8037 12.6743 12.8429 13.6312 11.6664 13.6312ZM7.01155 13.2037H11.6664C12.6076 13.2037 13.3763 12.4351 13.3763 11.4939C13.3763 10.5528 12.6076 9.78414 11.6664 9.78414H8.03508V10.1253H11.6664C12.4194 10.1253 13.0351 10.7371 13.0351 11.4939C13.0351 12.2469 12.4233 12.8626 11.6664 12.8626H7.1841L7.01155 13.2037Z"
      fill="#132365"
    />
    <path
      d="M6.66623 6.45465L7.05054 7.22328H11.1525C11.7878 7.22328 12.3054 7.74093 12.3054 8.37622C12.3054 9.01151 11.7878 9.52916 11.1525 9.52916H8.20348V10.2978H11.1525C12.2152 10.2978 13.0741 9.43504 13.0741 8.37622C13.0741 7.31347 12.2113 6.45465 11.1525 6.45465H6.66623Z"
      fill="#132365"
    />
    <path
      d="M11.1527 10.5135H7.99194V9.31745H11.1527C11.6704 9.31745 12.0939 8.89392 12.0939 8.37627C12.0939 7.85862 11.6704 7.43509 11.1527 7.43509H6.91743L6.31743 6.23901H11.1488C12.3253 6.23901 13.2861 7.19588 13.2861 8.37627C13.29 9.55274 12.3331 10.5135 11.1527 10.5135ZM8.41939 10.0861H11.1527C12.0939 10.0861 12.8625 9.31745 12.8625 8.37627C12.8625 7.43509 12.0978 6.66646 11.1527 6.66646H7.01155L7.18409 7.00764H11.1527C11.9057 7.00764 12.5213 7.61941 12.5213 8.37627C12.5213 9.13313 11.9096 9.7449 11.1527 9.7449H8.41939V10.0861Z"
      fill="#132365"
    />
    <path
      d="M8.58795 6.49408H7.81932V13.4156H8.58795V6.49408Z"
      fill="#132365"
    />
    <path
      d="M8.8037 13.6312H7.60762V6.28217H8.8037V13.6312ZM8.03507 13.2037H8.37625V6.70962H8.03507V13.2037Z"
      fill="#132365"
    />
    <path
      d="M9.52929 5.29761H8.76067V6.83486H9.52929V5.29761Z"
      fill="#132365"
    />
    <path
      d="M9.63507 6.9449H8.65076V5.19196H9.63507V6.9449ZM8.86644 6.72921H9.42331V5.40372H8.86644V6.72921Z"
      fill="#132365"
    />
    <path d="M11.1956 5.29761H10.427V6.83486H11.1956V5.29761Z" fill="#132365" />
    <path
      d="M11.3017 6.9449H10.3174V5.19196H11.3017V6.9449ZM10.5331 6.72921H11.09V5.40372H10.5331V6.72921Z"
      fill="#132365"
    />
    <path
      d="M9.52929 12.9915H8.76067V14.5287H9.52929V12.9915Z"
      fill="#132365"
    />
    <path
      d="M9.63507 14.6351H8.65076V12.8821H9.63507V14.6351ZM8.86644 14.4233H9.42331V13.0978H8.86644V14.4233Z"
      fill="#132365"
    />
    <path d="M11.1956 12.9915H10.427V14.5287H11.1956V12.9915Z" fill="#132365" />
    <path
      d="M11.3017 14.6351H10.3174V12.8821H11.3017V14.6351ZM10.5331 14.4233H11.09V13.0978H10.5331V14.4233Z"
      fill="#132365"
    />
    <path
      d="M10 16.8157C6.24315 16.8157 3.18433 13.7608 3.18433 10C3.18433 6.24315 6.23923 3.18433 10 3.18433C13.7569 3.18433 16.8157 6.23923 16.8157 10C16.8157 13.7569 13.7569 16.8157 10 16.8157ZM10 3.86668C6.61962 3.86668 3.86668 6.61962 3.86668 10C3.86668 13.3804 6.61962 16.1333 10 16.1333C13.3804 16.1333 16.1333 13.3804 16.1333 10C16.1333 6.61962 13.3804 3.86668 10 3.86668Z"
      fill="#132365"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="4.64859"
        y1="1.90134"
        x2="16.6352"
        y2="20.0415"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0051282" stop-color="#F1D200" />
        <stop offset="1" stop-color="#D27D00" />
      </linearGradient>
    </defs>
  </svg>
);
export default BTG;
